import { Type } from "class-transformer";
import { computed, observable } from "mobx";
import type { EntityValidationRules } from "../services/validationService";
import CountryLocalizationRequest from "./countryLocalizationRequest";
import Enum from "./enum";
import LanguageCode from "./languageCode";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class CreateCountryRequest extends Enum {
  /**
   * Country code in ISO 3166-1 Alpha-2 standard.
   */
  @observable
  code!: string;

  /**
   * Country name.
   */
  @observable
  name!: string;

  /**
   * Indicates if country is member of SEPA.
   */
  @observable
  isSepaMember!: boolean;

  /**
   * Countries localized names.
   */
  @observable
  @Type(() => CountryLocalizationRequest)
  localizations!: CountryLocalizationRequest[];
}

export default class CreateCountry extends CreateCountryRequest {
  constructor() {
    super();
    this.isSepaMember = false;
  }

  @computed
  get enName() {
    return this.localizations?.find(x => x.languageCode == LanguageCode.En)?.name;
  }
  set enName(value) {
    this.setLocalizationName(value, LanguageCode.En);
  }

  @computed
  get deName() {
    return this.localizations?.find(x => x.languageCode == LanguageCode.De)?.name;
  }
  set deName(value) {
    this.setLocalizationName(value, LanguageCode.De);
  }

  @computed
  get ruName() {
    return this.localizations?.find(x => x.languageCode == LanguageCode.Ru)?.name;
  }
  set ruName(value) {
    this.setLocalizationName(value, LanguageCode.Ru);
  }

  @computed
  get plName() {
    return this.localizations?.find(x => x.languageCode == LanguageCode.Pl)?.name;
  }
  set plName(value) {
    this.setLocalizationName(value, LanguageCode.Pl);
  }

  @computed
  get huName() {
    return this.localizations?.find(x => x.languageCode == LanguageCode.Hu)?.name;
  }
  set huName(value) {
    this.setLocalizationName(value, LanguageCode.Hu);
  }

  private setLocalizationName = (value: string | undefined, languageCode: LanguageCode) => {
    if (!this.localizations) {
      this.localizations = [];
    }

    let localization = this.localizations.find(x => x.languageCode == languageCode);
    if (!localization) {
      localization = {
        languageCode: languageCode,
        name: value ?? "",
      };
      this.localizations.push(localization);
    }

    localization.name = value ?? "";
  };
}

export const CountryValidationRules: EntityValidationRules<CreateCountry> = {
  name: {
    required: true,
  },
  enName: {
    required: true,
  },
  deName: {
    required: true,
  },
  ruName: {
    required: true,
  },
  plName: {
    required: true,
  },
  huName: {
    required: true,
  },
  code: {
    required: true,
    isLength: {
      min: undefined,
      max: 2,
    },
  },
  isSepaMember: {
    required: true,
  },
};
